import React, { Component } from "react";
/*
import List from '../List/List';
*/
import "./Main.css";
import RatingTable from "../RatingTable/RatingTable";

class Main extends Component {
  render() {
    return (
      <div className="main">
        <div className="title">
          <h2>SIC - Avaliação Qualitativa</h2>
          <p>
            Desde 15/01/2018, os cidadãos são solicitados a avaliar as respostas
            recebidas aos pedidos de informação que encaminham aos diversos
            órgãos do Governo do Estado da Paraíba, através do Serviço de
            Informação ao Cidadão. Abaixo, segue a lista dos órgãos que já
            tiveram ao menos uma resposta avaliada, bem como a média das notas
            recebidas, que vão de 1 a 5.
          </p>
        </div>
        <RatingTable
          anoExercicio={this.props.anoExercicio}
          trocaAno={this.trocaAno}
        />
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// /src/Main/Main.js